import { render, staticRenderFns } from "./radio-box.vue?vue&type=template&id=d7449498&scoped=true"
import script from "./radio-box.vue?vue&type=script&lang=js"
export * from "./radio-box.vue?vue&type=script&lang=js"
import style0 from "./radio-box.vue?vue&type=style&index=0&id=d7449498&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7449498",
  null
  
)

export default component.exports